import * as React from 'react';
import { NavLink ,Link} from 'react-router-dom';
import { useNavigate } from "react-router";
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import Button from '@mui/material/Button';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ListIcon from '@mui/icons-material/List';
import { toast } from "react-toastify";
import { ipfsUriToUrl } from '../utils/ipfs';
import Label from './label';
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

// metadata:{
//     "cover": "https://cloudflare-ipfs.com/ipfs/QmZ4vzkTwC3uPA1aNUh8jGr3rpeU5vHFSJp4YSi7HypEAf",
//     "colletionfrom": "a",
//     "image": "https://cloudflare-ipfs.com/ipfs/QmUrbRzWrVL8tUqBQ1ifqjCjQ8piP5sUcpQhVjUEcuijXd",
//     "symbol": "CCCCHHHGGG",
//     "colletionid": "0xD1E20C9401E3a469F3bDA0b952e11D85f9C0776C",
//     "name": "aaaagggggyyyyy",
//     "banner": "https://cloudflare-ipfs.com/ipfs/QmQWPoNUpsWicwvEgPU4MTj8upHtWPxXgBvpyxP9Zrqt6q",
//     "description": "o Learn More About It. You Are Welcome To Link To Your Own Webpage With More Details.",
//     "colletiontype": "ERC721",
//     "category": "Jewelry",
//     "properties": ""
// }

export default function ColletionCardv2({chainid, nft }) {
  const renderStatus = (
    <Label
      variant="filled"
      color={(nft?.metadata?.colletionfrom==='a' && 'info') || 'warning'} 
    >
      {(nft?.metadata?.colletionfrom==='a' && 'Created') || 'Imported'}
    </Label>
  );
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    // setExpanded(!expanded);
  };
  const navigate = useNavigate();  
  const handleEditClick = () => {
    if(nft?.metadata?.colletionfrom=='a'){
      navigate("/editcolletionv2/"+chainid+"&"+nft?.contract+"&"+nft?.tokenId, { replace: true });   
    }else if(nft?.metadata?.colletionfrom=='b'){
      navigate("/editimportcolletionv2/"+chainid+"&"+nft?.contract+"&"+nft?.tokenId, { replace: true });   
    }else{
      toast.error("Sorry,  This edit colletionv page does not support contract addresses from unknown sources.!");
      return; 
    }
       
  };  
  const nftslistClick = () => {
    navigate("/nftslistpage/"+chainid+"&"+nft?.metadata?.colletionid, { replace: true });
}

  const coverurl = ipfsUriToUrl(nft?.metadata?.cover||nft?.metadata?.featured_image) || `/assets/images/covers/cover_1.jpg`;
  const avatarUrl = ipfsUriToUrl(nft?.media)|| `/assets/images/avatars/avatar_1.jpg`;
  return (
    <Card  >
     
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
           <img src={avatarUrl} /> 
          </Avatar>
        } 
        title={nft?.metadata?.symbol}  
        subheader={<Typography
                sx={{ 
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '1',
                  WebkitBoxOrient: 'vertical', }} 
                color="text.primary"
                variant="body2"
              >
             {nft?.metadata?.name} 
              </Typography>}
      />
      <NavLink to={{pathname: `/nftslistpage/${chainid}&${nft?.metadata?.colletionid}`,}}>
      <CardMedia
        component="img"
        height="194"
        image={coverurl} 

      /> 
     </NavLink>
       {/* <CardActions disableSpacing>
        <Button variant="contained" size="small" onClick={handleEditClick}>edit</Button>
        <Button variant="contained" size="small" onClick={nftslistClick}>nfts</Button>
        {renderStatus}
      </CardActions> */}
      <CardActions disableSpacing>
        <IconButton aria-label="edit" onClick={handleEditClick}>
          <EditNoteIcon />
           <Typography variant="subtitle2"  >Edit
          </Typography>
        </IconButton>
        <IconButton aria-label="nfts" onClick={nftslistClick}>
          <ListIcon />  
           <Typography variant="subtitle2"  >NFTS
          </Typography>
        </IconButton>
        <ExpandMore 
          onClick={handleExpandClick} 
          aria-label="show more"
        >
          {renderStatus}
        </ExpandMore>
      </CardActions>
    </Card>
  );
}